import { axiosAiq } from 'config';

export const fetchEquipment = async (locationId) => {
    if (!locationId) {
        return [];
    }
    const response = await axiosAiq.get(`/client/access-equipment/location/${locationId}`);
    const { data } = response;
    return data;
};
